export const formatAirportIata = (airportName, airportCode) => {
  if (!airportName && !airportCode) return '--';
  return airportCode ? `${airportName} (${airportCode})` : airportName;
};